import React from 'react'
import styles from '../component/custom.module.css';
import Images from './Images';


const MidRegister = ({ executeScroll }) => {
    const imageStyle = {
        maxWidth: "100%",
        width: "100%",
        objectFit: "cover",
    }
    return (
        <section className={styles.MidRegisterSection}>
            <picture>
                <source media='(min-width: 700px)' srcset={require('../assets/amount-distribution.webp')} />
                <img loading="lazy" src={require('../assets/amount-distribution@sm.webp')} alt={'CTA'} />
                {/* mobile */}
            </picture>
        </section>
    );
};

export default MidRegister;

